<style src='@/resources/styles/recharge.css' scoped />


<template>
  <main class='view-results'>
    <div class='recharge-packages' v-if="! showThanks">
    <div class='inner'>
      <section class='what-came-up'>
        <h1 class='lead'>
          Recharge Naminus to keep improving the results.
        </h1>
        <p class='blurb left-aligned'>
          Whenever you 🙂 or 😍 a name, Naminus tweaks its understanding of your tastes, and generates another batch
          of 10 or so names.  That takes <strong>1 Credit</strong>. <br /><br />
          The more <strong>credits</strong> you have, the more you can 🙂 or 😍 to get better and better names. And
          the more chances of finding a name you'll love!<br/><br />

          <img v-if="fetchingDeets" src="@/resources/images/graphics/ajax-loader.gif" />
          <span v-if="! fetchingDeets">You currently have <strong>{{deets.remaining_credits}}</strong> credits.</span>
        </p>
      </section>

    </div>

    <div class='inner'>
      <div class='loader center'>
        <section class='word-results'>
            <Package v-bind:package="packages.app" @selected="gotoPackage" v-bind:loading="fetchingDeets" />
            
            <Package  v-bind:package="packages.full"  @selected="gotoPackage" v-bind:loading="fetchingDeets" />
        </section>
        
          <p class='blurb'>
            No questions asked, 30 day full refund.
          </p>
          
          <p class='blurb'>

            For contrast, <a href="https://www.hostpapa.com/blog/technology/unfortunate-truth-domain-squatting/"
                            target="_blank">domain squatters</a> charge $2k - $10k to sell lame-sounding used domains 🤮.
            <br><br>
            <!--
            Questions? You can check our <a href='#'>FAQs</a> or <a href='#'>Contact Us</a>

            <br><br>
            -->
          <div style="color: white" v-if="canGoBack">

              Not ready yet? <button class='edit-button' @click="goBack" >Go back</button>

          </div>
      </div>
    </div>
    <PaymentForm v-if="showPayment"
                 v-bind:package="package"
                 v-bind:deets="deets"
                 @paid="onTxnSuccess"
                 @closed="unsetPackage"  />
    </div><!--recharge-packages-->
    
         
    <div class='recharge-thankyou' v-if="showThanks">
      <div class='inner'>
      <section class='what-came-up'>
        <h1 class='lead'>
          Thank you for your purchase!
        </h1>
        <p class='blurb left-aligned'>
          You've purchased <strong>{{txn.credits}}</strong> credits for ${{txn.amount}}. We've emailed a receipt to
          <strong>{{txn.email}}</strong>.

          <br /><br />
          You now have <strong>{{txn.remaining_credits}}</strong> credits. That means, you can 🙂 or 😍 <strong>{{txn
          .remaining_credits}}</strong>
          names, and get around <strong>{{txn.words}}</strong> personalized names! 🎉

          <br /><br />

          Thank you, for your support. We're always here if you have any questions, or need any help.

          <br /><br />

          <button class='edit-button' @click="goBack" >Go back to finding a great name.</button>
        </p>

      </section>
      </div>
    </div>
  </main>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import PaymentForm from "../modules/payment/PaymentForm";
  import Package from "../extended/Package";
  import Packages from "../../Packages";


  export default {
    name: 'RechargeView',

    components: {
      Package,
      PaymentForm
    },

    data: function () {
      return {
        package: null,
        deets: null, //pre-purchase info, e.g number of current credits, email, etc
        showThanks: false,
        txn: null
      }
    },

    mounted() {
      this.pageLoaded(this.$route);
      this.fetchDeets();
    },

    computed: {
      ...mapGetters(['packageById']),

      packages() {
        return Packages;
      },

      slug() {
        return this.$route.params['slug'];
      },

      canGoBack() {
        return typeof this.slug !== 'undefined' && this.slug !== '' && this.slug.length > 3;
      },


      fetchingDeets() {
        return this.deets === null;
      },

      showPayment() {
        return this.package !== null && this.intent !== null;
      }
    },

    methods: {

      ...mapMutations(['setCredits']),
      ...mapActions(['reqPaymentIntent', 'prePurchaseInfo', 'pageLoaded']),

      fetchDeets() {
        this.deets = null;
        this.prePurchaseInfo().then(info => {
          window.console.log("Received pre-purchase info", info);
          this.deets = info;
          const app = info.packages.find(p => p.id === Packages.app.id);
          const full = info.packages.find(p => p.id === Packages.full.id);
          Packages.app.credits = app.credits;
          Packages.app.words = app.words;
          Packages.app.price = app.price;
          Packages.app.price_formatted = app.price_formatted;

          Packages.full.credits = full.credits;
          Packages.full.words = full.words;
          Packages.full.price = full.price;
          Packages.full.price_formatted = full.price_formatted;


          const pkgId = (this.$route.params['packageId']);
          const pkg = this.packageById(pkgId);
          if (pkg) {
            this.setPackage(pkg);
            window.console.log("Pkg:", pkgId, this.package)
          }
        })
      },

      goBack() {

        this.$router.push({path: `/results/${this.slug}`});
      },


      gotoPackage(pkg) {
        if (this.fetchingDeets)
          return; //wait till we get their email

        window.console.log("going to: ", pkg);
        this.$router.push({path: `/recharge/${this.slug}/${pkg.id}`});
        this.setPackage(pkg);
      },



      setPackage(pkg) {
        if (this.fetchingDeets)
          return; //wait till we get their email
        this.package = pkg;
      },


      unsetPackage() {
        this.package = null;
        this.$router.push({path: `/recharge/${this.slug}`});
        this.fetchDeets();
      },

      onTxnSuccess(txnDeets) {
        this.txn = txnDeets;
        this.setCredits(txnDeets);
        this.showThanks = true;
      }
    }
  }
</script>